import React from "react";
import { Typography, Link as MUIlink } from "@mui/material";
import styled from "@mui/system/styled";
import Link from "next/link";

const FileInfoWrapper = styled("div")`
  margin: 10px 0 20px;
`;

const createMarkup = (htmlcontent) => {
  return { __html: htmlcontent };
};

const FileInfo = ({
  fileTitle = null,
  filePublisher = null,
  fileType = null,
  fileRef = null,
  license = null,
}) => (
  <FileInfoWrapper>
    {fileTitle && (
      <Typography variant="body2">
        Name: <span dangerouslySetInnerHTML={createMarkup(fileTitle)} />
      </Typography>
    )}
    {filePublisher && (
      <Typography variant="body2">Publisher: {filePublisher}</Typography>
    )}
    {fileType && <Typography variant="body2">Filetype: {fileType}</Typography>}
    {fileRef && fileRef.bookURL && (
      <Typography variant="body2">
        Used in:{" "}
        <Link href={fileRef.bookURL} passHref={true}>
          <MUIlink>{fileRef.bookTitle}</MUIlink>
        </Link>
      </Typography>
    )}
    {license && <Typography variant="body2">License: {license}</Typography>}
  </FileInfoWrapper>
);

export default React.memo(FileInfo);
